const cn = {
    btn: {
        logout: '退出登录',
        Cancel: '取消',
        Reset: '重置',
        Confirm: '确认',
        addOrg: '新增成员',
        operation: '操作',
        viewmember: '查看成员',
        viewpermission: '查看权限',
        create: '新建',
        querySame: '查重',
        import: '导入',
        importing: '导入中...',
        importings: '导入中',
        export: '导出',
        exporting: '导出中...',
        exportings: '导出中',
        detail: '查看详情',
        edit: '编辑',
        delete: '删除',
        receive: '领取',
        receiving: '领取中...',
        deactivate: '停用',
        switchOpen: '启用',
        switchOpening: '启用中...',
        deactivating: '停用中...',
        transfer: '转移',
        transferIng: '转移中...',
        distribute: '分配',
        distributing: '分配中...',
        transferClient: '转客户',
        associatedContacts: '关联联系人',
        disassociate: '解除关联',
        uploadAttachment: '上传附件',
        viewAllRecords: '查看所有记录',
        viewPermission: '查看权限',
        upload: '上传',
        download: '下载',
        downloading: '下载中...',
        deleting: '删除中...',
        associatedOppty: '关联商机',
        associat: '关联',
        addNewRecord: '新增记录',
        publishing: '发布中...',
        uploading: '附件上传中，请稍后...',
        publishRecord: '发布记录',
        updating: '更新中...',
        update: '更新',
        addNewContact: '新增联系人',
        addNewClient: '新建客户',
        save: '保存',
        search: '查询',
        exportSelected: '导出所选',
        submit: '提交',
        importOppty: '商机导入',
        importContact: '联系人导入',
        importLead: '线索导入',
        putInLeadPool: '放入线索池',
        transferClienting: '转客户中...',
        pullInOpenSea: '放入公海',
        pullIning: '放入中...',
        importClient: '客户导入',
        transferLead: '线索转移',
        transferClients: '客户转移',
        editDetails: '编辑详情',
        changeStatus: '改状态',
        addAttachment: '新增附件',
        publicAttachment: '发布附件',
        createLeadTodo: '创建线索待办'
    },
    menu: {
        title: 'GBU CRM',
        dashboard: '仪表盘',
        lead: '线索',
        leadManagement: '线索管理',
        leadPool: '线索池',
        accounts: '客户',
        accountsManagement: '客户管理',
        publicData: '公海',
        contactManagement: '联系人管理',
        contactList: '联系人',
        businessManagement: '商机管理',
        business: '商机',
        label: '标签',
        analysis: '数据分析',
        leadAnalysis: '线索分析',
        accountAnalysis: '客户分析',
        businessAnalysis: '商机分析',
        setting: '系统设置',
        staffManagement: '组织与成员管理',
        permission: '角色与权限管理',
        roleManagement: '角色管理',
        userInfo: '个人中心'
    },
    users: {
        avatar: '头像',
        name: '姓名',
        userName: '用户名',
        baiduEmail: '百度邮箱',
        belongDepartment: '所属部门',
        departmentManagers: '部门主管',
        role: '角色'
    },
    selectOptions: {
        notPaidBack: '未回款',
        refunded: '已回款',
        expired: '已逾期',
        myselfSubordinates: '本人及下属',
        myselft: '本人',
        subordinates: '下属',
        followUpStatus: '跟进状态',
        notAllocated: '未分配',
        pending: '待处理',
        invalidLead: '无效线索',
        noReplay: '未回复',
        followingUp: '跟进中',
        noIntention: '无意向',
        converted: '已转化',
        terminated: '已停用',
        dealStatus: '成交状态',
        closedDeal: '已成交',
        blackList:'黑名单',
        meetingScheduled: '会议已安排',
        postCall: '通话后跟进',
        revisit: '回流客户',
        notClosed: '未成交',
        marketEventName: '市场活动名称',
        marketEvent: '市场活动',
        selfExpansion: '自拓',
        supervisorAllocation: '主管分配',
        superKeyAccount: '超级KA客户',
        keyAccount: 'KA客户',
        mediumAccount: '中型客户',
        smallAccount: '小微客户',
        serviceProvider: '服务商',
        ceo: 'CEO',
        cmo: 'CMO',
        otherManagement: '公司其他管理层',
        businessDirector: '商务负责人',
        businessManager: '商务',
        accountDirector: '运营负责人',
        accountManager: '运营',
        brandDirector: '品牌负责人',
        brandManager: '品牌对接人',
        others: '其他',
        clientVerification: '验证客户',
        needsAnalysis: '需求分析',
        proposalQuotation: '方案报价',
        businessNegotiation: '商务谈判',
        orderWon: '赢单',
        orderLost: '输单',
        salesOpportunityStage: '商机阶段',
        rebatePolicyNotMeetClientExpectations: '返点政策不符合客户预期',
        paymentPolicyNotMeetClientExpectations: '账期政策不符合客户预期',
        clientNotProvideMaterials: '客户无法提供佐证材料',
        productChanges: '产品有变动',
        paymentIssues: '支付方式原因',
        otherReasons: '其他原因（自定义填写）',
        opptyStageText1: '了解客户公司基本情况（如公司背景和人员规模、主营业务、目标国家和地区等）',
        opptyStageText2: '了解客户在其他渠道的广告消耗规模',
        opptyStageText3: '了解客户公司的业务需求（如推广产品、投放目标、广告预算、投放痛点等）',
        opptyStageText4: '了解客户是否需要代投服务',
        opptyStageText5: '向客户推荐投放渠道，并介绍相关媒体和优秀案例',
        opptyStageText6: '向客户提供商务政策（如账期、返点、服务费等）',
        opptyStageText7: '与客户确认投放渠道和商务政策',
        opptyStageText8: '向客户提供媒体投放方案',
        opptyStageText9: '如客户申请特殊账期和返点政策，搜集佐证材料进行内部申请',
        man: '男',
        women: '女',
        mediagoAgency: 'MediaGo agency',
        mediagoDsp: 'MediaGo DSP',
        facemojiKeyboard: 'Facemoji输入法变现',
        popinDiscovery: 'popIn Discovery',
        preinstalledBusiness: '厂商预装业务',
        selfInvestment: '自投',
        agentInvestment: '代投'
    },
    formInfo: {
        pleaseSelectPriority: '请选择优先级',
        pleaseSelectPaymentStatus: '请选择回款状态',
        needZipCode: '请输入正确的邮编',
        mpweRequire: '手机/电话/微信号/邮箱，请至少填1个',
        pleaseEnter: '请输入',
        pleaseEnterContent: '请输入内容',
        pleaseEnterSearchScope: '请输入查询范围和条件',
        pleaseSelect: '请选择',
        noData: '暂无数据',
        leadSelectFileText1: '将文件拖拽到这里进行导入 或 ',
        leadSelectFileText2: '选择文件',
        leadUploadFileText1:'SalesGo线索导入模板',
        contactUploadFileText1: 'SalesGo联系人导入模板',
        opptyUploadFileText1: 'SalesGo商机导入模板',
        clientUploadFileText1: 'SalesGo客户导入模板',
        opptyUploadFileText2: '先下载模板，按模板格式编辑相关信息',
        opptyUploadFileText3: ' 在这里上传想要批量导入的名单,仅支持excel文件(.xlsx) ',
        onlyImportXlsFile: '只能上传 xls/xlsx 文件!',
        maxFileTip: '文件大小不能超过',
        duplicateFileTip: '重复的数据导入不成功，已下载至本地',
        downloadTemplate: '下载模板',
        pleaseSelectIndustryPlaceholder: '请选择客户行业',
        pleaseSelectSub:'请选择细分品类',
        pleaseSelectIndustry: '请先选择客户行业',
        pleaseSelectopptyLine: '请先选择业务线',
        isConfirmDeleteAttachment: '确认删除附件吗?',
        isConfirmDeleteRecord: '确认删除记录吗?',
        isConfirmDisassociate: '确定要解除关联吗？',
        isConfirmUpdateStatus: '确定更新成交状态？',
        isConfirmUpdateFollowupStatus: '确定更新跟进状态？',
        isConfirmStopCustomer: '确定停用客户吗？',
        isConfirmStopLead: '确定停用线索吗？',
        isConfirmStopData: '确定要停用吗？',
        isConfirmOpenData: '确定要启用吗？',
        isConfirmOpenLead: '确定启用线索吗？',
        isConfirmOpenCloseLead: '确定停用/启用线索吗？',
        isConfirmUpdatePrimaryContact: '确定要更新首要联系人吗？',
        isCOnfirmReceiveData: '确认领取？',
        uploadNotAllowed: '抱歉，暂不支持上传这种文件类型',
        pleaseSelectLeadStop: '请选择要停用或者要启用的线索',
        searchSomeText: '搜索相关内容',
        pleaseSelectSearchType: '请选择搜索类型',
        pleaseEnterOrderLostReason: '请输入具体原因描述',
        needPhoneNumber: '手机号码需为6-15位数字',
        phoneIsNumber: '电话号码为数字',
        emailType: '请输入正确格式的邮箱',
        querySameNoData: '暂无数据,请先搜索查重~',
        pleaseSelectAccounts: '请选择领取的客户',
        pleaseSelectOpptyStage: '请选择商机阶段',
        pleaseSelectBusinessline: '请选择业务线',
        pleaseSelectCooperationChannels: '请选择合作渠道',
        pleaseSelectCooperationType: '请选择合作方式',
        pleaseSelectFollowupStatus: '请选择跟进状态',
        pleaseSelectLeadSource: '请选择线索来源',
        pleaseSelectLeadSourceTip: '请选择线索来源',
        pleaseSelectLeadLevel: '请选择线索等级',
        pleaseSelectCountry: '请选择国家',
        pleaseSelectBusinessTip:'业务线为MediaGo agency时可选',
        pleaseSelectCountryTip: '请选择国家',
        pleaseSelectCity: '请选择城市',
        pleaseSelectTargetLocation: '请选择推广区域',
        followupStatusText: '以下跟进状态，可选',
        systemFollowupStatusText: '以下是系统跟进状态，不可选',
        isConfirmPullinLeadpool: '确定将线索放入线索池吗？',
        isConfirmTransferCustomer: '确定转客户？',
        pleaseSelectDealStatus: '请选择成交状态',
        pleaseSelectClientSource: '请选择客户来源',
        pleaseSelectClientSourceTip: '请选择客户来源',
        pleaseSelectClientLevel: '请选择客户等级',
        pleaseSelectClient: '请选择客户',
        isConfirmPullClientToOpensea: '确定将客户放入公海吗？',
        pleaseSelectClientStop: '请选择要停用或者要启用的客户',
        pleaseSelectPosition: '请选择职位',
        needTelephoneNumber: '电话号码需为6-15位数字',
        pleaseEnterdepartmentName: '请输入部门名称',
        pleaseEnterName: '请输入姓名',
        pleaseEnterOpptyName: '请输入商机名称',
        pleaseEnterClientName: '请输入客户名称',
        pleaseEnterContactName: '请输入联系人名称',
        pleaseEnterLeadName: '请输入线索名称',
        pleaseEnterNumber: '请输入有效的数字',
        pleaseSelectDepartment: '请选择上级部门',
        pleaseSelectLoseReason: '请选择输单原因',
        pleaseSelectLoseReasonInfo: '请输入输单具体原因',
        pleaseSelectRole: '请选择角色',
        pleaseSelectPersonInCharge: '请选择负责人',
        pleaseSelectPersonInChargePlaceholder: '请选择负责人',
        pleaseSelectLeftSide: '请先从左侧选择筛选类型',
        isConfirmDeleteDepartment: '确定要删除该部门吗？',
        isConfirmDeleteUser: '确定要删除该用户吗？',
        leadTemplate: 'SalesGo线索导入模板.xlsx',
        leadLink:"/api/conf/get_file?key=2024/06/25/d41d8cd98f00b204e9800998ecf8427e_1719301797735972466.xlsx",
        clientTemplate: 'SalesGo客户导入模板.xlsx',
        clientLink:"/api/conf/get_file?key=2024/06/25/d41d8cd98f00b204e9800998ecf8427e_1719301862519021354.xlsx",
        contactTemplate: 'SalesGo联系人导入模板.xlsx',
        contactLink:"/api/conf/get_file?key=2024/06/25/d41d8cd98f00b204e9800998ecf8427e_1719301888476345457.xlsx",
        opptyTemplate: 'SalesGo商机导入模板.xlsx',
        opptyLink:"/api/conf/get_file?key=2024/03/12/d41d8cd98f00b204e9800998ecf8427e_1710254104017874438.xlsx",
        importInfo:'导入失败，文件已下载至本地，请参照表格导入失败说明列进行修改',
        downloadFile:'导入失败文件.xlsx',
        deleteInfo:'是否确定删除？',
    },
    backEnd: {
        superAdmin: '超级管理员',
        superAdminText1: '预置角色,不可删除,支持当前所有组织数据的所有读写操作',
        businessManager: '商务经理',
        businessManagerText1: '预置角色,不可删除,访问个人及本下级所有数据的所有读写操作',
        businessSpecialist: '商务专员',
        businessSpecialistText1: '预置角色,不可删除,支持访问个人所有数据的部分读写操作'
    },
    common: {
        priority: '优先级',
        weeklyReport: '周报',
        generateWeekly: '生成周报',
        selectWeeklyDate: '选择周报日期',
        month: '月份',
        expiredDays: '逾期天数',
        billExpireHistory: '账单逾期历史',
        paymentStatus: '回款状态',
        selectFollowupTime: '选择待办结束时间',
        addFollowupTodo: '创建跟进待办',
        type: '类型',
        name: '名称',
        leadModuleId: '线索ID',
        clientModuleId: '客户ID',
        contactModuleId: '联系人ID',
        opptyModuleId: '商机ID',
        leadData: '线索数据',
        opptyData: '商机数据',
        customerData: '客户数据',
        startDate: '开始日期',
        endDate: '结束日期',
        followupDateStart: '待办开始时间',
        followupDateEnd: '待办结束时间',
        followupFinish: '待办结束时间',
        Date: '日 期',
        compared: '对比',
        filterConditions: '过滤条件：',
        notfound404: '抱歉～找不到页面，还剩 <span class="timer" style="color: #2888ff;">{ second }</span> 秒返回首页',
        backHomepage: '返回首页',
        contactInfoma: '联系人信息',
        unknown: '未知',
        chinajoyText1: '2023年chinajoy活动扩展',
        gameIndustry: '游戏行业',
        ordinal: '第{rank}名',
        data: '数据',
        addressss: '地址-省市',
        addressAllText: '地址-省市区',
        zipcode: '邮政编码',
        number: '数量',
        amount: '金额',
        myRanking: '我的排名',
        meiyuan: 'USD',
        items: '个',
        user: '用户',
        rankList: '排行榜',
        rank: '排行',
        saleFunnel: '销售漏斗',
        distributeAccount: '客户分配',
        distributeLead: '线索分配',
        clientFollowupTip: '客户跟进提醒',
        dataSum: '数据汇总',
        compareLastMonth: '较上月',
        new: '新增',
        salesBrief: '销售简报',
        module: '模块',
        moduleName: '模块名称',
        phoneEmailWechat: '手机号/邮箱/微信号',
        clientDuplication: '客户查重',
        addNewOppty: '新增商机',
        conversionRate: '转化率',
        selected: '已选择',
        records: '条',
        switchOpen: '启用',
        switchClose: '禁用',
        uploador: '上传人',
        opptyNumbers: '商机数量',
        isPrimaryContact: '是否首要联系人',
        primaryContact: '首要联系人',
        primaryContactsPhone: '首要联系人手机号',
        yes: '是',
        no: '否',
        time: '时间',
        followupRecords: '跟进记录',
        details: '详细资料',
        attachment: '附件',
        contactExperience: '联系人经历',
        systemMsg: '系统信息',
        baseInfo: '基本信息',
        promotionalInfo: '推广信息',
        attachmentName: '附件名称',
        attachmentSize: '附件大小',
        uploadTime: '上传时间',
        noPermission: '无权限',
        leadName: '线索名称',
        leadSource: '线索来源',
        leadLevel: '线索等级',
        relatedMarketEvents: '关联市场活动',
        industry: '客户行业',
        addressAll: '地址-省/市/区',
        city: '所在城市',
        address: '详细地址',
        contactPerson: '联系人',
        gender: '性别',
        position: '职务',
        cellPhone: '手机',
        telePhone: '电话',
        wechat: '微信',
        email: '邮箱',
        productName: '产品名称',
        companySite: '公司官网',
        subcategories: '细分品类',
        targetLocation: '推广区域',
        aveDailySpend: '竞媒日均消耗',
        aveDailyBudget: '日均推广预算',
        notes: '备注',
        customTag: '自定义标签',
        followupRecord: '跟进记录',
        followupStatus: '跟进状态',
        finishTime: '待办结束时间',
        personCharge: '负责人',
        accountManager:'AM',
        lastContactTime: '最近沟通时间',
        lastFollowuoRecord: '最新跟进记录',
        duration: '持续时间',
        creator: '创建人',
        creationTime: '创建时间',
        clientName: '客户名称',
        clientSource: '客户来源',
        clientLevel: '客户等级',
        opptyName: '商机名称',
        opptyAmount: '商机金额（USD）',
        opptyAmountUnit: '商机金额（USD）',
        estimatedTime: '预计成交时间',
        businessLine: '业务线',
        cooperationChannels: '合作渠道',
        cooperationMethod: '合作方式',
        rebate: '返点',
        legalEntity: '签约主体',
        productLink: '产品链接',
        country: '国家'
    },
    settings: {
        orgManagement: '组织管理',
        createDepartment: '新建组织',
        departmentName: '部门名称',
        parentDepartment: '上级部门',
        departmentLeader: '部门主管',
        postname: '岗位',
        createMember: '新建成员',
        baiduEmail: '百度邮箱',
        status: '状态',
        name: '姓名',
        phone: '手机号',
        sex: '性别',
        role: '角色',
        roleDesc: '描述',
        forDepartment: '所属部门',
        created_at: '创建时间',
        email: '邮箱',
        man: '男',
        women: '女',
        manandwomen: '未知',
        admin: '超级管理员',
        businessAdmin: '商务经理',
        businesser: '商务专员',
        avatar: '头像',
        userName: '用户名',
        creator: '创建人',
        normalUser: '正常',
        disableUser: '禁用',
        staffManagement: '人员管理',
        roleManagement: '角色管理',
        userInfo: '个人中心',
        memberList: '成员列表',
        emptyText: '该分组下暂无成员，请新增成员~',
        switchOpen: '启用',
        switchClose: '禁用',
        roleandmembersList: '角色与成员管理',
        addDepartment: '新增部门',
        editDepartment: '编辑部门'
    },
    analysis: {
        lineChart: '折线图',
        barChart: '柱状图',
        pieChart: '饼图',
        funnelChart: '漏斗图',
        adwancedFiltering: '高级过滤',
        customColumns: '自定义列',
        greaterOrEqual: '大于或等于',
        lessOrEqual: '小于或等于',
        enterNumbers: '输入相关数字',
        between: '介于',
        notBetween: '不介于',
        dragDropRecorder: '拖放以重新排序',
        selected: '已选',
        Reset: '重置',
        indicatorName: '指标名称',
        selectAll: '全选',
        monthOnMonth: '环比',
        previousTime: '相邻前一时间段',
        aggregateDimension: '聚合维度',
        searchDimension: '搜索维度',
        reportData: '报表数据',
        collapseLegend: '收起图例',
        expandLegend: '展开图例',
        functionalLevel: '功能层级',
        organizationalLevel: '组织层级',
        timeLevel: '时间层级',
        leadLevel: '线索层级',
        clientLevel: '客户层级',
        opportunityLevel: '商机层级',
        moduleLevel: '模块层级',
        byYear: '分年',
        byQuarter: '分季度',
        byMonth: '分月',
        byWeek: '分周',
        byDay: '分日',
        aggregateDimensionType: '聚合维度分类',
        searchDimensionType: '搜索维度分类',
        pleaseSelectAggregateDimension: '请至少选择一个聚合维度',
        systemModule: '系统模块',
        systemLevel: '系统层级',
        //报表名称
        LeadStatistics: '线索统计',
        ClientStatistics: '客户统计',
        ClientgradeAnalysis: '客户等级分析',
        ClientindustryAnalysis: '客户行业分析',
        FollowUpRecordAnalysis: '跟进记录分析',
        OpportunityStatistics: '商机统计',
        OpportunityStageAnalysis: '商机阶段分析',
        opptyDataAnalysis: '商机统计分析',
        currentDate: '当前日期',
        compareDates: '对比日期',
        present: '当前',
        contrast: '对比',
        orgLevelName: '{orgLevel}级组织',
        total: '总数'
    },
    indicator: {
        // 线索分析
        addNewLead: '新增线索',
        leadToClient: '线索转客户',
        leadToClientRate: '线索转客户占比',
        leadToClientConverted: '已成交线索转客户',
        leadToClientConvertedRate: '已成交线索转客户占比',
        leadToClientUnsold: '未成交线索转客户',
        leadToClientUnsoldRate: '未成交线索转客户占比',
        contactedLead: '已建联线索',
        contactedLeadRate: '已建联线索占比',
        noReplyLead: '未回复线索',
        noReplyLeadRate: '未回复线索占比',
        invalidLead: '无效线索',
        invalidLeadRate: '无效线索占比',
        unintentionalLeads: '无意向线索',
        unintentionalLeadsRate: '无意向线索占比',
        noAssignedLeads: '未分配线索',
        noAssignedLeadsRate: '未分配线索占比',
        pendingLeads: '待处理线索',
        pendingLeadsRate: '待处理线索占比',
        // 客户分析
        closedClients: '已成交客户',
        closedClientsRate: '已成交客户占比',
        noClosedClients: '未成交客户',
        noClosedClientsRate: '未成交客户占比',
        newClient: '新增客户',
        newClosedClient: '新增已成交客户',
        newClosedClientRate: '新增已成交客户占比',
        newNotClosedClient: '新增未成交客户',
        newNotClosedClientRate: '新增未成交客户占比',
        contactPerson: '联系人',
        newContact: '新增联系人',
        opptyAmount: '商机金额',
        newAccountFollowUpRecords: '新增客户跟进记录',
        //商机分析
        addNewOppty: '新增商机',
        addOpptyAmount: '新增商机金额',
        validClientStageOpptyNumber: '验证客户阶段商机数',
        validClientStageOpptyAmount: '验证客户阶段商机金额',
        validClientStageOpptyNumberRate: '验证客户商机数占比',
        analysisStageOpptyNumber: '需求分析阶段商机数',
        analysisStageOpptyAmount: '需求分析阶段商机金额',
        analysisStageOpptyNumberRate: '需求分析商机数占比',
        quotationStageOpptyNumber: '方案报价阶段商机数',
        quotationStageOpptyAmount: '方案报价阶段商机金额',
        quotationStageOpptyNumberRate: '方案报价商机数占比',
        negotiationStageOpptyNumber: '商务谈判阶段商机数',
        negotiationStageOpptyAmount: '商务谈判阶段商机金额',
        negotiationStageOpptyNumberRate: '商务谈判商机数占比',
        wonOpptyNumber: '赢单商机数',
        wonOpptyAmount: '赢单商机金额',
        wonOpptyNumberRate: '赢单商机数占比',
        lostOpptyNumber: '输单商机数',
        lostOpptyAmount: '输单商机金额',
        lostOpptyNumberRate: '输单商机数占比',
        //商机分析-销售阶段
        saleStageOpptyNumber: '销售阶段总商机数',
        saleStageLoseNumber: '销售阶段流失数',
        saleStageConversionNumber: '销售阶段转化数',
        saleStageOpptyHoldNumber: '销售阶段停留数',
        saleStageOpptyAmount: '销售阶段总商机金额',
        saleStageOpptyLoseNumber: '销售阶段流失商机金额',
        saleStageOpptyHoldAmount: '销售阶段停留商机金额',
        saleStageClientAmount: '销售阶段客户数',
        saleStageAveClientPrice: '销售阶段平均客单价',
        saleStageAvecycle: '销售阶段平均销售周期',
        saleStageConversionRate: '销售阶段转化率',
        //客户跟进记录
        followupRecords: '跟进记录',
        addFollowup: '新增跟进记录',
        longerDays7: '持续时间超7天',
        longerDays14: '持续时间超14天',
        longerDays30: '持续时间超30天',
        longerMonth3: '持续时间超3个月',
        longerMonth6: '持续时间超6个月',
        longerMonth12: '持续时间超12个月',
        noContactlongerDays7: '超过7天未联系',
        noContactlongerDays14: '超过14天未联系',
        noContactlongerDays30: '超过30天未联系',
        noContactlongerMonth3: '超过3个月未联系',
        noContactlongerMonth6: '超过6个月未联系',
        noContactlongerMonth12: '超过12个月未联系'
    },
    date: {
        today: '今天',
        yesterday: '昨天',
        beforeToday: '今天之前',
        totalDate: '全部时间',  
        tommorow: '明天',
        thisWeek: '本周',
        lastWeek: '上周',
        nextWeek: '下周',
        thisMonth: '本月',
        lastMonth: '上月',
        nextMonth: '下月',
        thisQuarter: '本季度',
        lastQuarter: '上季度',
        nextQuarter: '下季度',
        thisYear: '今年',
        lastYear: '去年',
        nextYear: '明年'
    },
    msg: {
        deleteDone: '删除成功',
        confirmDone: '保存成功',
        updateDone: '更新成功',
        stopDone: '停用成功',
        enableDone: '启用成功',
        receiveDone: '领取成功',
        receiveError: '领取失败',
        confirmError: '保存失败，请稍后再试',
        uploadError: '附件上传失败，请重新上传',
        workDone: '操作成功',
        workError: '操作失败',
        waitExport: '正在导出中，耐心等待...',
        importDone: '导入成功',
        importError: '导入失败',
        exportDone: '导出成功',
        exportError: '导出失败',
        leadpoolDone: '放入线索池成功',
        leadpoolError: '放入线索池失败',
        transferClientDOne: '转客户成功',
        isConfirmRelogin: '登录已过期，确定要重新登录吗',
        networkError: '网络错误',
        noPermissionContact: '无权限，请联系管理员！',
        expiredRelogin: '身份已过期，请重新登录',
        permissionText: '暂无访问权限，请联系管理员处理 ~'
    },
    toolTip: {
        dataAnalysisChartTip: '图表暂不支持查看以下维度：细分行业，地区-省市区、市场活动',
        dashboardChartTip: '近一个月数据变化情况',
        leadList: '线索管理',
        leadListEx:
            '线索是与客户初次接触获得的原始信息，可以是从展会中获得的名片，通过推广活动获得的电话号码，或是会议、广告、外部购买等渠道获得的客户简单信息，然后通过管理和跟进可以转化为客户。',
        leadPoolEx:
            `线索池指整个企业的一个共有的线索池，其中客户来源于两部分:
    1：成员主动选中线索放入线索供其他成员认领。
    2：所有成员的线索信息，针对手机等联系方式进行脱敏处理。`,
        leadNameEx: '线索名称 / 客户名称 填写企业名称',
        leadPeopleEx: '线索/客户对应的联系人名称',
        PromotionAreaEx: '线索/客户的意向投放推广区域',
        dailyConsumptionEx: '线索/客户的在业界其他媒体投放消耗，单位为USD',
        promotionBudgetEx: '线索/客户的预估日均推广预算，单位为USD',
        followStatusEx:
        `-可选状态:
    * 无效线索：联系方式虚假、人员虚假等情况
    * 未回复：联系方式虚假、人员虚假等情况
    * 跟进中：已建联，同时对线索/客户进行跟进
    * 无意向：判断该线索暂无合作意向
-系统状态：
    * 未分配：暂未分配责任人
    * 待处理：判断该线索暂无合作意向
    * 已转化：判断该线索可转化为客户后，点击“转客户”按钮后的状态
    * 已停用：判断该线索咱不跟进后，点击“停用”按钮后的状态`,
        accountsManager: '客户管理',
        accountsManagerEx:
            '客户是指通过购买你的产品或服务满足其某种需求、产生直接经济关系的团体或企业，可以通过线索转化而来，或是直接新建等多种渠道获取。',
        accountsPool: '公海',
        accountsPoolEx:
            `公海指整个企业的一个共有的客户池，其中客户来源于两部分:
    1：成员主动选中客户放入公海供其他成员认领;
    2：所有成员的客户信息，针对手机等联系方式进行脱敏处理`,
        contactEx:
            '联系人指与客户企业对接时可进行沟通的企业员工。无论员工企业角色，能保持沟通与联络即可录入联系人，并与客户信息关联。',
        businessEx:
            '商机即销售机会，销售人员在与客户沟通的过程中，发现了客户的购买意向，从而推动客户从意向到实际购买的这个过程就是商机管理。',
        dashBoardEx:
            '所选时间段内的销售成果对比分析。包括客户、联系人、商机、商机金额和跟进记录，展现其在所选时间段内的增长情况。环比是与上一个相邻统计周期相比较，如相邻两周的数据对比。',
        salesFunnelEx: '销售漏斗数据来源于商机管理模块，显示筛选条件下各商机的销售阶段，通过金额和数量两种形式展示。',
        dataSummaryEx: '汇总线索、客户、商机模块相关信息，提供新增、转化、跟进状态等相关信息。',
        RankingListEx: '排行榜显示在筛选条件下根据不同排名维度的前十位的员工信息。',
        CustomerFollowEx: '展示筛选条件下在不同时间间隔中未添加跟进记录或者长时间未联系的客户数。',
        leadLevelEx:
            `-超级KA客户：处于行业领先地位的头部企业或知名品牌，如名列同类产品榜单top 100的企业/产品
-KA客户：整体投放预算在50,000美元/天以上的客户
-中型客户：整体投放预算在5,000美元/天以上的客户
-小微客户：整体投放预算在5,000美元/天以下的客户
-服务商：行业生态里的其他服务商，如支付公司、物流公司、广告代理商，具备潜在的资源合作机会`,
        RelatedMarketEx: '当线索来源 / 客户来源为市场活动时，可填写关联的市场活动',
        TransactionStatusEx: 
        `已成交：已完成首次合作的客户;
未成交：有意向但仍在推进的客户`,
        contactPeopleEx: '指定客户关联的联系人名称',
        businessNameEx: '指定客户关联的商机名称',
        businessCountEx: '指定商机对应的商机金额，单位为USD',
        ContractingEntityEx: '指定商机签约的客户主体名称',
        ContactDurationTimeEx: '联系人持续时间：当前时间 - 创建时间',
        leadDurationTimeEx:
            '线索持续时间： 如果已转化，持续时间= 转化时间 - 创建时间， 如果未转化，持续时间= 当前时间 - 创建时间',
        accountDurationTimeEx:
            '客户持续时间：如果已成交，持续时间=成交时间-创建时间，如果未成交，持续时间= 当前时间 - 创建时间',
        opDurationTimeEx: '商机持续时间：当前商机阶段的当前时间-阶段开始时间',
        unknownEx: '未知'
    }
};

export default cn;
